import { useEffect, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';

import { onboardingQuestionnaireActions } from '../../../../../../store';

import type { AppDispatch } from '../../../../../../store';
import type { IOnboardingQuestionnaireDocument } from '../../../../../../pages/questionnaires/onboarding/types';

export function usePreviewOnboardingQuestionnaireDocument(onboardingQuestionnaireId: string) {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const [previewingDocument, setPreviewingDocument] =
    useState<IOnboardingQuestionnaireDocument | null>(null);
  const [previewLoadingDocumentId, setPreviewLoadingDocumentId] = useState<number | null>(null);
  const previewRequestIdRef = useRef(0);

  useEffect(() => {
    previewRequestIdRef.current += 1;
    setPreviewingDocument(null);
    setPreviewLoadingDocumentId(null);
  }, [onboardingQuestionnaireId]);

  const closePreview = () => setPreviewingDocument(null);

  const openPreview = async (document: IOnboardingQuestionnaireDocument) => {
    if (document.document_url) {
      setPreviewingDocument(document);
      return;
    }

    const requestId = previewRequestIdRef.current + 1;
    previewRequestIdRef.current = requestId;
    setPreviewLoadingDocumentId(document.id);

    const result = await dispatch(
      onboardingQuestionnaireActions.getOnboardingQuestionnaireDocumentDetails({
        onboardingQuestionnaireId,
        documentId: String(document.id),
        getAccessTokenSilently,
      }),
    );

    if (requestId !== previewRequestIdRef.current) return;

    setPreviewLoadingDocumentId(null);

    if (
      onboardingQuestionnaireActions.getOnboardingQuestionnaireDocumentDetails.fulfilled.match(
        result,
      )
    ) {
      setPreviewingDocument(result.payload);
    }
  };

  return {
    closePreview,
    openPreview,
    previewLoadingDocumentId,
    previewingDocument,
  };
}
